import React from 'react'

const CloseModal = ({ handleModal }) => {
    return (
        <div className='flex-shrink-0 h-fit cursor-pointer' onClick={handleModal}>
            <img src="https://assets.learntube.ai/files/New%20Analysis%20Page/Close.svg?updatedAt=1742903383647" width={25} height={25} alt="" className='' />
        </div>
    )
}

export default CloseModal